<template>
  <v-dialog v-model="dialog" width="600" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>CHI TIẾT BUỔI HỌC</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>

      <v-card-text class="black--text">
        <div class="pt-6" v-if="currentSlot && currentSlot.slot">
          <div class="font-weight-bold mb-2">
            1. Chi tiết buổi học
          </div>
          <v-row no-gutters>
            <v-col cols="4" class="sub-header">
              Ngày
            </v-col>
            <v-col cols="8"> {{ currentSlot.slot.day | scheduleDay }}, {{ currentDate | ddmmyyyy }} </v-col>
            <v-col cols="4" class="sub-header">
              Tiết
            </v-col>
            <v-col cols="8">
              {{ currentSlot.slot.index }}
            </v-col>
            <v-col cols="4" class="sub-header">
              Môn
            </v-col>
            <v-col cols="8">
              <div v-if="$_get(currentSlot, 'slot.classNote.metadata.slot.subject.title')">
                {{ currentSlot | _get('slot.classNote.metadata.slot.subject.title') }}
              </div>
              <div v-else>
                {{ currentSlot | _get('teaching.subject.title') }}
              </div>
            </v-col>
            <v-col cols="4" class="sub-header">
              Giáo viên
            </v-col>
            <v-col cols="8">
              <router-link
                target="_blank"
                v-if="$_get(currentSlot, 'slot.classNote.metadata.slot.teacher.id')"
                :to="'/teacher/' + $_get(currentSlot, 'slot.classNote.metadata.slot.teacher.id')"
                style="text-decoration: none !important"
              >
                {{ currentSlot | _get('slot.classNote.metadata.slot.teacher.name') }}
              </router-link>
              <router-link
                target="_blank"
                v-else-if="$_get(currentSlot, 'slot.teacher')"
                :to="'/teacher/' + currentSlot.slot.teacher"
                style="text-decoration: none !important"
              >
                {{ currentSlot | _get('teaching.teacher.name') }}
              </router-link>
            </v-col>
          </v-row>

          <div class="font-weight-bold my-2">
            2. Nội dung học
          </div>
          <v-row no-gutters>
            <v-col cols="4" class="sub-header">
              Tiết theo PPCT
            </v-col>
            <v-col cols="8">
              {{ currentSlot | _get('slot.classNote.data.lessonIndex') }}
            </v-col>
            <v-col cols="4" class="sub-header">
              Nội dung
            </v-col>
            <v-col cols="8">
              {{ currentSlot | _get('slot.classNote.lesson') }}
            </v-col>
          </v-row>

          <div class="font-weight-bold my-2">
            3. Khen thưởng kỷ luật
          </div>
          <div v-if="$_get(currentSlot, 'slot.classNote.currentViolations.length')">
            <div v-for="violation in currentSlot.slot.classNote.currentViolations" :key="violation.id">
              <span>
                <router-link
                  target="_blank"
                  :to="'/student/' + violation.student.id"
                  style="text-decoration: none !important"
                >
                  {{ violation.student.name }} ({{ violation.student.code | getStudentCode }})
                </router-link>
              </span>
              <span>
                -
                <span :style="violation.type === 'violation' ? 'color: red' : 'color: green'">
                  {{ violation.type | violation }}
                </span>
                -
              </span>
              <span>
                {{ violation.description }}
              </span>
            </div>
          </div>

          <div class="font-weight-bold my-2">
            4. Điểm số
          </div>
          <div v-if="$_get(currentSlot, 'slot.classNote.currentMarks.length')">
            <div v-for="mark in currentSlot.slot.classNote.currentMarks" :key="mark.id">
              <span>
                <router-link
                  target="_blank"
                  :to="'/student/' + mark.student.id"
                  style="text-decoration: none !important"
                >
                  {{ mark.student.name }} ({{ mark.student.code | getStudentCode }}) -
                </router-link>
              </span>
              <span v-if="mark.subject.markType === 'mark'">
                <span :style="{ color: getMarkColor(mark.value) }">
                  {{ mark.value }}
                </span>
                ({{ mark.factor.type | factorType }})
              </span>
              <span v-else>{{ mark.value | getEvaluate }}</span>
            </div>
          </div>

          <div class="font-weight-bold my-2">
            5. Nhận xét lớp học
          </div>
          <v-row no-gutters>
            <v-col cols="4" class="sub-header">
              Điểm lớp học
            </v-col>
            <v-col cols="8">
              {{ currentSlot | _get('slot.classNote.data.classMark') }}
            </v-col>
            <v-col cols="4" class="sub-header">
              Nhận xét
            </v-col>
            <v-col cols="8">
              {{ currentSlot | _get('slot.classNote.data.classComment') }}
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed color="primary" class="ma-2 white--text" @click="cancel">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import { mapActions, mapState } from 'vuex'

export default {
  components: {},
  props: {
    state: Boolean,
    currentSlot: {
      type: Object,
      default: () => {}
    },
    currentDate: String
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {},
  methods: {
    getMarkColor(mark) {
      if (mark >= 8) return 'green'
      if (mark >= 6 && mark <= 7) return 'orange'
      return 'red'
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
<style scoped>
.sub-header {
  color: rgba(0, 0, 0, 0.6);
}
</style>
